import React from 'react'
import {CardBody} from 'reactstrap'

const card=(props)=>(<CardBody {...props}/>)

export default card;